import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { SITE_CONTENT } from "../content";

const ServicesGridSection = () => {
  const { title, subtitle, services } = SITE_CONTENT.pages.homePage.servicesSection;

  const handleCtaClick = (e, link) => {
    if (link.startsWith("#")) {
      e.preventDefault();
      const el = document.querySelector(link);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <section className="bg-[#051109] text-white py-24 lg:py-32 relative overflow-hidden" id="services">
      {/* Background Ambience */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#006B54]/15 rounded-full blur-[140px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-[#E8A040]/10 rounded-full blur-[150px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full border border-[#E8A040]/40 bg-[#E8A040]/10 text-[#E8A040] text-xs font-bold tracking-[0.25em] uppercase mb-4 shadow-[0_0_20px_rgba(232,160,64,0.15)]">
            Tailored For Every Celebration
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light font-serif text-[#f8f4ee] mb-4">
            {title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#E8A040] to-transparent mx-auto mb-6" />
          <p className="text-[#a0aaa2] text-base sm:text-lg font-light leading-relaxed max-w-xl mx-auto">
            {subtitle}
          </p>
        </div>

        {/* 7 Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, idx) => (
            <div
              key={service.id}
              className={`group rounded-2xl bg-[#0a1f12]/90 border border-[#1f3a29] overflow-hidden flex flex-col justify-between hover:border-[#E8A040]/60 hover:bg-[#0c2717] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_40px_-15px_rgba(232,160,64,0.2)] ${
                idx === 6 ? "md:col-span-2 lg:col-span-1" : ""
              }`}
            >
              {/* Image Preview with Overlay */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700 filter brightness-[0.85]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a1f12] via-[#0a1f12]/30 to-transparent" />
                
                {/* Badge */}
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-[#051109]/80 backdrop-blur-md border border-white/20 text-[#E8A040] text-[11px] font-bold tracking-widest uppercase shadow">
                    0{idx + 1}
                  </span>
                </div>
              </div>

              {/* Text Content */}
              <div className="p-7 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="text-xl font-medium font-serif text-[#f5eedf] mb-3 group-hover:text-[#F5C070] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-[#8e9c91] text-sm leading-relaxed font-light mb-6">
                    {service.description}
                  </p>
                </div>

                {/* Exact Docx CTA Button */}
                <div className="pt-4 border-t border-white/10">
                  <a
                    href={service.ctaLink}
                    onClick={(e) => handleCtaClick(e, service.ctaLink)}
                    className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-[#E8A040] group-hover:text-white transition-colors"
                  >
                    <span>{service.ctaText}</span>
                    <FaArrowRight className="w-3 h-3 transition-transform group-hover:translate-x-1" />
                  </a>
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServicesGridSection;

